import styled from "styled-components";

export const JOB_PAGE_IMAGE_SIZE_SPEC = {
  width: 487,
  minHeight: 255,
  maxHeight: 487,
  minAspect: 1,
  maxAspect: 1.91
};

export const textStyle = {
  fontWeight: 400,
  fontSize: "14px",
  lineHeight: "1.2em"
};

export const PostEditorJobPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: ${JOB_PAGE_IMAGE_SIZE_SPEC.width}px;
  box-shadow: 0px 2px 4px 0px #1516331f;
  border-radius: 4px;
  background: white;
  padding: 20px;
  font-family: Rubik;
  position: relative;
`;

export const EditorWrapper = styled.div`
  margin: 5px 10px 14px;
  border: 1px solid grey;
  border-radius: 5px;
`;

export const LogoEditorWrapper = styled.div`
  display: flex;
  justify-content: center;
`;

export const TextSection = styled.div`
  margin-bottom: 20px;
  text-align: left;
  margin-top: ${({ mt }) => mt}px;
`;

export const Label = styled.label`
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.04em;
  color: #536586;
  text-transform: uppercase;
`;

export const OpenLeadForm = styled.a`
  font-size: 12px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 4px;

  p {
    color: #536586;
  }
  i {
    transition: transform 0.25s ease-in-out;
  }

  &:hover {
    p {
      color: #1e22ff;
      text-decoration: underline;
    }
    i {
      transform: scale(1.2);
    }
  }
`;
